module.exports = __webpack_public_path__ + "static/media/svgicons8-flag_2.bf863cd6.svg";